import React, { useState, useEffect, useCallback } from 'react';
import { Box, Paper, Typography, Button, Toolbar } from '@mui/material';
import { BsClockHistory } from 'react-icons/bs';
import { styled } from '@mui/material/styles';
import { SearchInput, ComboBox } from 'components';
import { ClientCarelist } from './client-care-list';
import { DrawerLeadWaitCare } from './drawer-lead-wait-care';
import ApiServices from 'services';
import { CLIENT_STATUS_ID, CLIENT_STATUS_NAME } from 'commons/constants';
import Utils from 'commons/utils';
import { BsArrowDownCircle } from 'react-icons/bs';
import moment from 'moment';
import { debounce } from 'lodash';

const ClientCareHistory = () => {
  const { NEAR_LEAD, CONFER_LEAD, FILTER_LEAD } = CLIENT_STATUS_ID;
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [columns, setColumns] = useState({});
  const [columnsOriginCare, setColumnsOriginCare] = useState([]);
  const [columnsOriginDeal, setColumnsOriginDeal] = useState([]);
  const [columnsOriginDealSuccess, setColumnsOriginDealSuccess] = useState([]);
  const [loading, setLoading] = useState(false);

  const [operatorList, setOperatorList] = useState([]);
  const [operatorSelected, setOperatorSelected] = useState([]);

  const fetchOperators = async () => {
    try {
      const res = await ApiServices.getOperators();
      // console.log(res?.data);
      setOperatorList(res?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchOperators();
  }, []);

  const getDataInit = async (newParams = '') => {
    let [getLeadsTakingCare, getDeals, getDealsSuccessful] = await Promise.all([
      ApiServices.getClientCareHistoryByStatus(NEAR_LEAD, newParams),
      ApiServices.getClientCareHistoryByStatus(CONFER_LEAD, newParams),
      ApiServices.getClientCareHistoryByStatus(FILTER_LEAD, newParams),
    ]);

    const mapDataCare = getLeadsTakingCare?.data?.map((item) => {
      item.textSearch = `${item?.objClientCompany?.code}${item?.objClientCompany?.name}`;
      return item;
    });
    const mapDataDeal = getDeals?.data?.map((item) => {
      item.textSearch = `${item?.objClientCompany?.code}${item?.objClientCompany?.name}`;
      return item;
    });
    const mapDataDealSuccess = getDealsSuccessful?.data?.map((item) => {
      item.textSearch = `${item?.objClientCompany?.code}${item?.objClientCompany?.name}`;
      return item;
    });

    setColumnsOriginCare(mapDataCare || []);
    setColumnsOriginDeal(mapDataDeal || []);
    setColumnsOriginDealSuccess(mapDataDealSuccess || []);

    setColumns({
      [FILTER_LEAD]: {
        name: CLIENT_STATUS_NAME['FILTER_LEAD'],
        items: mapDataDealSuccess || [],
        columnId: FILTER_LEAD,
      },
      [NEAR_LEAD]: {
        name: CLIENT_STATUS_NAME['NEAR_LEAD'],
        items: mapDataCare || [],
        columnId: NEAR_LEAD,
      },
      [CONFER_LEAD]: {
        name: CLIENT_STATUS_NAME['CONFER_LEAD'],
        items: mapDataDeal || [],
        columnId: CONFER_LEAD,
      },
    });
  };

  React.useEffect(() => {
    getDataInit();
  }, []);

  const timeoutGetData = useCallback(
    debounce((newParams) => {
      getDataInit(newParams);
    }, 500),
    [],
  );
  useEffect(() => {
    const params = operatorSelected
      ?.map((item) => `operatorCodes=${encodeURIComponent(item?.code)}`)
      .join('&');

    const checkParams = params.length > 0 ? `?${params}` : '';
    timeoutGetData(checkParams);
  }, [operatorSelected]);

  const handleExport = async (dataOperator) => {
    const dataOperatorSelected = dataOperator?.map((item) => item.code);
    setLoading(true);
    await ApiServices.exportLeadTakingCare(
      `?ClientStatusIds=${FILTER_LEAD}&ClientStatusIds=${NEAR_LEAD}&ClientStatusIds=${CONFER_LEAD}`,
      dataOperatorSelected,
    )
      .then((res) => {
        if (res?.data) {
          Utils.exportTemplate(
            res?.data,
            `DS_Leads_Dang_Cham_Soc_${Utils.formatSimpleDate(moment())}.xlsx`,
          );
        }
      })
      .catch((err) => {
        console.log('Export Tempalte error:', err);
        window.UIMessage?.error('Tải thất bại !!!');
      });
    setLoading(false);
  };

  const handleFilterData = (query, dataInit, idColumn) => {
    let dataFilter = [];
    dataInit?.map((item) => {
      let checkFilter = true;
      if (query) {
        if (!Utils.convertValSearch(item?.textSearch)?.includes(Utils.convertValSearch(query))) {
          checkFilter = false;
        }
      }

      if (checkFilter) {
        dataFilter.push(item);
        return;
      } else {
        return;
      }
    });

    setColumns((prev) => {
      prev[idColumn].items = dataFilter;
      return { ...prev };
    });
  };

  const handleSearchColumn = (value, dataColumn, dataInit) => {
    switch (dataColumn.columnId) {
      case NEAR_LEAD:
        handleFilterData(value, dataInit, NEAR_LEAD);
        return;

      case CONFER_LEAD:
        handleFilterData(value, dataInit, CONFER_LEAD);
        return;

      case FILTER_LEAD:
        handleFilterData(value, dataInit, FILTER_LEAD);
        return;

      default:
        break;
    }
  };

  const handleChangeOperator = useCallback(
    (_, newValue) => {
      setOperatorSelected(newValue || []);
    },
    [operatorSelected],
  );

  return (
    <>
      <Container>
        <Header>
          <Typography variant="h6" id="tableTitle" component="div">
            LEADS ĐANG CHĂM SÓC
          </Typography>
          <ContainerRight>
            <Box sx={{ width: '40%' }}>
              <ComboBox
                multiple
                disableCloseOnSelect
                options={operatorList}
                label="Đơn vị vận hành"
                sx={{ width: '100%' }}
                keyField="code"
                isOptionEqualToValue={(option, value) =>
                  Boolean(option?.code) && option.code === value?.code
                }
                value={operatorSelected}
                onChange={handleChangeOperator}
              />
            </Box>
            <ButtonExport
              variant="outlined"
              startIcon={<BsArrowDownCircle />}
              onClick={() => handleExport(operatorSelected)}
            >
              Tải excel
            </ButtonExport>
          </ContainerRight>
          {/* <ContainerRight>
            <SearchInput sx={{ mr: 2 }} />
            <LeadWaitCare
              variant="contained"
              size="small"
              startIcon={<BsClockHistory />}
              onClick={() => setIsOpenDrawer(true)}
              // onMouseOver={() => console.log('')}
            >
              Chờ chăm sóc
            </LeadWaitCare>
          </ContainerRight> */}
        </Header>

        <ClientCarelist
          columns={columns}
          setColumns={setColumns}
          getDataInit={getDataInit}
          handleSearchColumn={handleSearchColumn}
          columnsOriginCare={columnsOriginCare}
          columnsOriginDeal={columnsOriginDeal}
          columnsOriginDealSuccess={columnsOriginDealSuccess}
        />
      </Container>

      <DrawerLeadWaitCare
        isOpen={isOpenDrawer}
        setIsOpen={setIsOpenDrawer}
        getDataInit={getDataInit}
      />
    </>
  );
};

export { ClientCareHistory };

const Container = styled(Paper)(({ theme }) => ({
  width: '100%',
  mb: 1,
  position: 'relative',
  overflow: 'hidden',
}));

const Header = styled(Toolbar)(({ theme }) => ({
  pl: { sm: 2 },
  pr: { xs: 1, sm: 1 },
}));

const ContainerRight = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  mr: 2,
}));

const LeadWaitCare = styled(Button)(({ theme }) => ({
  borderRadius: '20px',
  marginLeft: '8px',
  color: '#FFFFFF',
  backgroundColor: '#F9A907',
  '.MuiButton-endIcon': {
    marginLeft: '0px',
  },
  padding: '0px 16px',
}));
export const ButtonExport = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '10px',
  marginLeft: '8px',
  color: '#6C757D',
  border: '1px solid rgba(0, 0, 0, 0.4)',
  '.MuiButton-startIcon': {
    marginRight: '5px',
  },
}));
